const marketType = {
  serverSide: true,
  autocomplete: true,
  values: [
    { id: 'MC', name: 'Marche comptage' },
    { id: 'MCI', name: 'Marche comptage interessement' },
    { id: 'SANS', name: 'Sans type marche' },
    { id: 'MFI', name: 'Marche forfait interessement' },
    { id: 'CP', name: 'Combustible prestation' },
    { id: 'MT', name: 'Marche temperature' },
    { id: 'MF', name: 'Marche forfait' },
    { id: 'AT.AS', name: 'At sans four. Comb' },
    { id: 'AT.RS', name: 'At revise sans four. Comb' },
    { id: 'PF', name: 'Prestation forfait' },
    { id: 'AT.RA', name: 'At revise avec four comb' },
    { id: 'AT.AA', name: 'At avec four comb' },
    { id: 'MTI', name: 'Marche temperature interessement' },
    { id: 'CPI', name: 'Combustible prestation interessement' },
    { id: 'PFI', name: 'Prestation forfait interessement' },
  ],
};

export const PURPOSE_LIST = [
  { id: 'BCO', name: 'Bâtiment communal ' },
  { id: 'COM', name: 'Local commercial ' },
  { id: 'CUL', name: 'Equipement socio-culturel' },
  { id: 'DIV', name: 'Autre ' },
  { id: 'ECO', name: 'Ecole primaire, Groupe Scolaire' },
  { id: 'HOP', name: 'Hôpital, clinique' },
  { id: 'HOT', name: 'Hôtellerie' },
  { id: 'HPR', name: 'Habitat privé' },
  { id: 'HSO', name: 'Habitat social' },
  { id: 'IND', name: 'Industrie hors bâtiments tertiaires' },
  { id: 'MUS', name: 'Multi usage' },
  { id: 'PIS', name: 'Piscine' },
  { id: 'PRI', name: 'Prison' },
  { id: 'RET', name: 'Maison de retraite' },
  { id: 'SEC', name: 'Enseignement secondaire et supérieur' },
  { id: 'SPO', name: 'Equipements sportifs' },
  { id: 'TEC', name: 'Local Technique Communal ' },
  { id: 'TER', name: 'Bâtiment de bureaux' },
];

export const TRANSMITTER_TYPES = [
  { id: 'Automatisme Alienor', name: 'Automatisme Alienor' },
  { id: 'Automatisme Niv3', name: 'Automatisme Niv3' },
  {
    id: 'Automatisme Predity Sous-Station',
    name: 'Automatisme Predity Sous-Station',
  },
  { id: 'Automatisme STC', name: 'Automatisme STC' },
  { id: 'Biomasse', name: 'Biomasse' },
  {
    id: 'Chaufferie Centrale(Ademe-COCKPIT-TopP1)',
    name: 'Chaufferie Centrale(Ademe-COCKPIT-TopP1)',
  },
  { id: 'Cogénération', name: 'Cogénération' },
  { id: 'Inconnu', name: 'Inconnu' },
  { id: 'Kit Predity Sous-Station', name: 'Kit Predity Sous-Station' },
  { id: 'KIT Smart Terminal', name: 'KIT Smart Terminal' },
  { id: 'Passerelle Satchwell', name: 'Passerelle Satchwell' },
  { id: 'Piscines', name: 'Piscines' },
  { id: 'Predity Monitoring 3G', name: 'Predity Monitoring 3G' },
  { id: 'Predity Pilote', name: 'Predity Pilote' },
  { id: 'Supervision - S/St Reseau', name: 'Supervision - S/St Reseau' },
  { id: 'Téléalarmes, Télécomptages', name: 'Téléalarmes, Télécomptages' },
  { id: 'Vapeur', name: 'Vapeur' },
  { id: 'Vigionell', name: 'Vigionell' },
];

export default marketType;
